
import { LitElement, html } from 'lit-element';
import translate from '../utils/webcomponents/translate';

import './icon';

const renderIcon = (icon, size) => (icon
	? html`
		<span class="message__icon">
			<x-icon icon="${icon}" size="${size}"></x-icon>
		</span>
	`
	: '');

const renderMessage = (message, resourceObject = {}) => {
	const { resourceName, labelKey } = resourceObject;

	if (!message && !resourceName && !labelKey) {
		return '';
	}

	if (message) {
		return html`${message}`;
	}

	return translate(resourceName, labelKey);
};

class Message extends LitElement {
	static get properties() {
		return {
			icon: { type: String },
			iconSize: { type: String },
			message: { type: String },
			resource: { type: Object },
			modifier: { type: String },
		};
	}

	constructor() {
		super();

		this.iconSize = 's';
	}

	render() {
		return html`
			<div class="message message--center ${this.modifier ? `message--${this.modifier}` : ''} message--appear">
				${renderIcon(this.icon, this.iconSize)}
				${renderMessage(this.message, this.resource)}
			</div>
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-message', Message);

export default Message;
